import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";

import { Icon } from "@/components/ui-v2";
import { useNextAppRolloutEnabled } from "@/core/app/components/NextAppRollout";
import { useTrackNextAppSwitch } from "@/hooks";
import { getWebAppLoginUrl } from "@/utils/env";

import { PrimaryNavigationItemBase } from "../../../PrimaryNavigationLinks/components/PrimaryNavigationLink/components/PrimaryNavigationItemBase";

export const NextAppButton = () => {
  const isRolloutEnabled = useNextAppRolloutEnabled();
  const trackNextAppSwitch = useTrackNextAppSwitch();

  const onTryNextApp = () => {
    trackNextAppSwitch("sidebar");
  };

  if (!isRolloutEnabled) return null;

  const startIcon = (
    <Box
      sx={{
        height: 36,
        width: 36,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon icon={faArrowUpRightFromSquare} />
    </Box>
  );

  return (
    <PrimaryNavigationItemBase
      as="a"
      icon={startIcon}
      label="Try the new Layer"
      href={getWebAppLoginUrl()}
      onClick={onTryNextApp}
      style={{
        width: "100%",
      }}
    />
  );
};
